export const MILES_TEXT = 'mi';
export const KM_TEXT = 'km';
export const TRAVEL_MODE_DRIVING = 'driving';